// extracted by mini-css-extract-plugin
export default {"outlet":"layout_outlet__P2rDg"};